import React, {Component} from 'react';
import {observer} from "mobx-react";
import Row from "./Row";
import {StoreContext} from "../../stores/contexts";

class Body extends Component {
  static contextType = StoreContext;
  renderRows() {
    if(this.context.dataStore.data && this.context.dataStore.data.data.items) {

      return this.context.dataStore.data.data.items.map((item,index)=>{
        return (
          <Row key={index} item={item} externalRenderer={this.props.externalRenderer} />
        )
      })
    }
    return null;
  }
  render() {
    if(!this.context.dataStore.data.inited) {
      return null;
    }
    return (
      <tbody>
        {this.renderRows()}
      </tbody>
    )
  }
}

// export default inject("configStore","dataStore","selectStore","dragStore")(observer(Body));
export default observer(Body);